import { useEffect, useState } from 'react';

const matches = (query: string): boolean =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;

/**
 * Whether a CSS media query currently matches, updated as the window is resized.
 */
export const useMediaQuery = (query: string): boolean => {
    const [isMatch, setIsMatch] = useState(() => matches(query));

    useEffect(() => {
        if (typeof window.matchMedia !== 'function') {
            return undefined;
        }
        const mediaQueryList = window.matchMedia(query);
        const onChange = () => setIsMatch(mediaQueryList.matches);
        onChange();
        // addListener/removeListener for Safari < 14, which lacks addEventListener on MediaQueryList
        mediaQueryList.addListener(onChange);
        return () => mediaQueryList.removeListener(onChange);
    }, [query]);

    return isMatch;
};
